import Footer from "../../../Components/Footer";
import Home from "./Home";
import UnauthedContent from "./UnauthedContent";
import UnauthedHeader from "./UnauthedHeader";

import "./UnauthedPage.css";

const UnauthedPage = (props) => {
  const { onLogin, page, emailVerificationToken, email } = props;
  return (
    <div className="unauthed-home-page-container">
      <UnauthedHeader page={page} />
      <UnauthedContent
        onLogin={onLogin}
        page={page}
        emailVerificationToken={emailVerificationToken}
        email={email}
      />
      <Footer />
    </div>
  );
};

export default UnauthedPage;
